import store from '../store';

const initAuthOnLoad = {
    onLoad: 'check-sso',
    checkLoginIframe: false,
    //silentCheckSsoRedirectUri: window.location.origin + "/silent-check-sso.html",
};

const initAuthConfig = {
    url: process.env.VUE_APP_AUTH_KEYCLOAK_URL,
    realm: process.env.VUE_APP_AUTH_KEYCLOAK_REALM,
    clientId: process.env.VUE_APP_AUTH_KEYCLOAK_CLIENT_ID,
    offlineToken: true
};

// keycloak-js >= 18 sends this as `post_logout_redirect_uri`, which Keycloak
// validates against the client's "Valid post logout redirect URIs" — a
// different list from the plain redirect URIs used at login.
const logoutRedirectUri = () => window.location.origin;

const logoutUser = () => {
    // Clear local state first: logout() navigates away immediately.
    window.localStorage.removeItem('mpi-logbook-auth');
    store.getters['userAuth/getAllKeycloak'].logout({
        redirectUri: logoutRedirectUri()
    });
};

export {
    initAuthOnLoad,
    initAuthConfig,
    logoutRedirectUri,
    logoutUser
};
